module.exports = __webpack_public_path__ + "static/media/SUN.5c2e1687.png";